// history.js
import { createBrowserHistory } from "history";

const history = createBrowserHistory()

// Get the current location.
const location = history.location


export default history